/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ net: NonNullable<unknown>, vat: NonNullable<unknown>, gross: NonNullable<unknown> }} Billing_Vat_BreakdownInputs */



/**
* | output |
* | --- |
* | "{net} excl. VAT + {vat} VAT = {gross} to be charged" |
*
* @param {Billing_Vat_BreakdownInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const billing_vat_breakdown = /** @type {((inputs: Billing_Vat_BreakdownInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Vat_BreakdownInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.net} zzgl. ${i?.vat} MwSt. = ${i?.gross} werden abgebucht`)
	return /** @type {LocalizedString} */ (`${i?.net} excl. VAT + ${i?.vat} VAT = ${i?.gross} to be charged`)
});